"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function SvgVisibilityEmphasize(props) {
    return (React.createElement("svg", __assign({ viewBox: '0 0 16 16', xmlns: 'http://www.w3.org/2000/svg' }, props),
        React.createElement("path", { d: 'm7.98938 3a8.86159 8.86159 0 0 0 -7.98938 5.531 8.85011 8.85011 0 0 0 7.99591 5.5332 8.149 8.149 0 0 0 3.88825-.9978 9.42277 9.42277 0 0 0 4.09454-4.5354 8.86157 8.86157 0 0 0 -7.98932-5.531zm3.39471 9.14026a7.064 7.064 0 0 1 -3.38818.8714 7.69441 7.69441 0 0 1 -6.83331-4.48047 7.69634 7.69634 0 0 1 6.82678-4.4787 7.69606 7.69606 0 0 1 6.82642 4.47815 8.33827 8.33827 0 0 1 -3.43171 3.60962zm-3.54931-6.19836a5.2435 5.2435 0 0 1 4.43494 2.4846 5.20194 5.20194 0 0 1 -8.87043.001 5.24358 5.24358 0 0 1 4.43549-2.4856m0-1a6.20673 6.20673 0 0 0 -5.57478 3.48423 6.20193 6.20193 0 0 0 11.14954 0 6.2067 6.2067 0 0 0 -5.57476-3.48423z', opacity: 0.55 }),
        React.createElement("path", { d: 'm10.36261 6.58888a5.39549 5.39549 0 0 0 -2.53-.67 5.213 5.213 0 0 0 -2.57.7 2.70985 2.70985 0 0 0 -.23 1.1 2.785 2.785 0 0 0 5.57.00066v-.00066a2.69655 2.69655 0 0 0 -.24-1.13zm-3.60261 1.83331a1.05319 1.05319 0 1 1 1.05317-1.05319 1.05324 1.05324 0 0 1 -1.05317 1.05319z' })));
}
exports.default = SvgVisibilityEmphasize;
